
















































































































































import Vue from 'vue';
import { mapState } from 'vuex';
// import {
//   getAllConferences,
//   delConference,
//   updateConference,
// } from '@/api/conference';
import Search from '@/components/Search/index.vue';
import Confirmation from '@/components/Confirmation/index.vue';
import AddConference from '@/components/AddConference/index.vue';
// eslint-disable-next-line no-unused-vars
import { conferenceType } from '@/types/api';
import Details from './components/Details/index.vue';
import Motions from './components/Motions/index.vue';
import Delegates from './components/Delegates/index.vue';

export default Vue.extend({
  name: 'Conference',
  components: {
    Search,
    Details,
    Confirmation,
    AddConference,
    Motions,
    Delegates,
  },
  data() {
    return {
      showConfirm: false as boolean | string,
      showInput: false as boolean,
      editData: {} as Partial<conferenceType.getConference>,
      filteredData: [] as conferenceType.getAllConferences[],
      // filter: '' as string,
      conf: null,
      sel: null as number | null,
      key: 0 as number,
      transEnd: false,
      config: {
        // @ts-ignore
        handler: this.outside,
        events: ['click', 'touchstart', 'touchmove'],
      },
      configAdd: {
        handler: () => {
          // @ts-ignore
          this.showConfirm = 'add';
        },
        middleware: (event) => event.target.className !== 'cancel' && event.target.className !== 'list',
        events: ['click', 'touchstart', 'touchmove'],
      },
      motions: null,
      error: null,
      delegates: null,
      conferencesData:
        [
          {
            _id: 'example',
            title: 'Example Conference',
            start_date: new Date(Date.now()).toISOString(),
            end_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
            rules: {
              majority: '1/2 Delegates + 1',
              dr_vote: '2/3 Delegates',
              quorum: '2/3 Delegates',
              rounding: 'Round Down',
            },
            chairman: [{
              _id: 'john',
              email: 'johndoe@example.com',
            },
            {
              _id: 'admin',
              email: 'admin@example.com',
            }],
            delegates: [
              {
                _id: 'indonesia',
                country: 'Indonesia',
                status: 'present',
              },
              {
                _id: 'usa',
                country: 'United States of America',
                status: 'present & voting',
              },
            ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
          },
          {
            _id: 'future',
            title: 'Future Conference',
            start_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
            end_date: new Date(Date.now() + (3600 * 1001 * 24 * 2)).toISOString(),
            rules: {
              majority: '1/2 Delegates + 1',
              dr_vote: '2/3 Delegates',
              quorum: '2/3 Delegates',
              rounding: 'Round Down',
            },
            chairman: [{
              _id: 'john',
              email: 'johndoe@example.com',
            },
            {
              _id: 'admin',
              email: 'admin@example.com',
            }],
            delegates: [
              {
                _id: 'indonesia',
                country: 'Indonesia',
                status: 'present',
              },
              {
                _id: 'usa',
                country: 'United States of America',
                status: 'present & voting',
              },
            ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
          },
        ] as conferenceType.getAllConferences[],
    };
  },
  methods: {
    dateFormat(d): string {
      const sDate = new Date(d);
      const ye = (y) => new Intl.DateTimeFormat('en', { year: 'numeric' }).format(y);
      const mo = (m) => new Intl.DateTimeFormat('en', { month: '2-digit' }).format(m);
      const da = (day) => new Intl.DateTimeFormat('en', { day: '2-digit' }).format(day);
      return `${ye(sDate)}-${mo(sDate)}-${da(sDate)}`;
    },
    exitAdd(): void {
      this.showInput = false;
    },
    delegate(items: conferenceType.getAllConferences[]): conferenceType.getAllConferences[] {
      return items.filter((item) => item.chairman
        .some((chair) => chair.email !== this.$store.state.Global.me.email));
    },
    chair(items: conferenceType.getAllConferences[]): conferenceType.getAllConferences[] {
      return items.filter((item) => item.chairman
        .some((chair) => chair.email === this.$store.state.Global.me.email));
    },
    ongoing(items: conferenceType.getAllConferences[]): conferenceType.getAllConferences[] {
      const dt: Date = new Date(Date.now());
      return items.filter((item) => {
        const a: Date = new Date(item.start_date);
        const b: Date = new Date(item.end_date);
        const c: Date = new Date(b.getTime());
        c.setDate(c.getDate() + 1);
        return dt >= a && dt < c;
      });
    },
    filterFunc(
      items: conferenceType.getAllConferences[],
      tags: string[],
      search: string,
    ): conferenceType.getAllConferences[] {
      let list = items;
      if (search !== '') {
        list = list.filter(
          (item) => item.title.toLowerCase().indexOf(search.toLowerCase()) > -1,
        );
      }
      if (tags.includes('Delegate')) {
        list = this.delegate(list);
      }
      if (tags.includes('Chair')) {
        list = this.chair(list);
      }
      if (tags.includes('Ongoing')) {
        list = this.ongoing(list);
      }
      if (tags.includes('Best Delegate')) {
        console.error('No backend support!'); // wait for backend
      }
      return list;
    },
    sortFunc(
      items: conferenceType.getAllConferences[],
      type: string,
      dir: string,
    ): conferenceType.getAllConferences[] {
      if (type === 'Date') {
        items.sort((a, b) => {
          const dateA = Date.parse(a.end_date);
          const dateB = Date.parse(b.end_date);
          let compare;
          switch (dir) {
            case 'down':
              compare = dateA > dateB;
              break;
            case 'up':
              compare = dateA < dateB;
              break;
            default:
          }
          switch (compare) {
            case true:
              return -1;
            case false:
              return 1;
            default:
              return 0;
          }
        });
      } else if (type === 'Name') {
        items.sort((a, b) => {
          let compare;
          switch (dir) {
            case 'up':
              compare = a.title.toLowerCase() < b.title.toLowerCase();
              break;
            case 'down':
              compare = a.title.toLowerCase() > b.title.toLowerCase();
              break;
            default:
          }
          switch (compare) {
            case true:
              return -1;
            case false:
              return 1;
            default:
              return 0;
          }
        });
      }
      return items;
    },
    outside(): void {
      this.showInput = false;
      this.editData = {};
      this.showConfirm = false;
    },
    showC(event: MouseEvent, data: conferenceType.getConference, index: number): void {
      if (!this.showInput) {
        this.$store.dispatch('context', [
          [data.title, data._id, index],
          {
            Edit: true,
            Delete: true,
          },
          [event.clientX, event.clientY],
        ]);
      }
    },
    showCon(data: conferenceType.getConference, index: number) {
      return (event) => {
        if (!this.showInput) {
          this.$store.dispatch('context', [
            [data.title, data._id, index],
            {
              Edit: true,
              Delete: true,
            },
            [event.touches[0].clientX, event.touches[0].clientY],
          ]);
        }
      };
    },
    context(): void {
      if (!this.showInput && this.contextData.action === 'Delete') {
        this.showConfirm = this.contextData.name;
      } else if (!this.showInput) {
        this.showInput = true;
        this.editData = this.filteredData[this.contextData.index];
        this.sel = this.conferencesData.findIndex((i) => i._id === this.contextData.id);
      }
    },
    select(i: number): void {
      this.sel = i;
    },
    toggleInput(t: string): void {
      if (t === 'add') {
        this.editData = {};
      } else {
        this.editData = this.filteredData[t];
      }
      this.showInput = true;
    },
    updateConferencesData(): void {
      // try {
      //  const conferences = await getAllConferences();
      const conferences = [
        {
          _id: 'example',
          title: 'Example Conference',
          start_date: new Date(Date.now()).toISOString(),
          end_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
          rules: {
            majority: '1/2 Delegates + 1',
            dr_vote: '2/3 Delegates',
            quorum: '2/3 Delegates',
            rounding: 'Round Down',
          },
          chairman: [{
            _id: 'john',
            email: 'johndoe@example.com',
          },
          {
            _id: 'admin',
            email: 'admin@example.com',
          }],
          delegates: [
            {
              _id: 'indonesia',
              country: 'Indonesia',
              status: 'present',
            },
            {
              _id: 'usa',
              country: 'United States of America',
              status: 'present & voting',
            },
          ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
        },
        {
          _id: 'future',
          title: 'Future Conference',
          start_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
          end_date: new Date(Date.now() + (3600 * 1001 * 24 * 2)).toISOString(),
          rules: {
            majority: '1/2 Delegates + 1',
            dr_vote: '2/3 Delegates',
            quorum: '2/3 Delegates',
            rounding: 'Round Down',
          },
          chairman: [{
            _id: 'john',
            email: 'johndoe@example.com',
          },
          {
            _id: 'admin',
            email: 'admin@example.com',
          }],
          delegates: [
            {
              _id: 'indonesia',
              country: 'Indonesia',
              status: 'present',
            },
            {
              _id: 'usa',
              country: 'United States of America',
              status: 'present & voting',
            },
          ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
        },
      ] as conferenceType.getAllConferences[];
      if (conferences !== null) {
        this.conferencesData = conferences;
        this.key += 1;
      //   }
      // } catch (err) {
      //   this.error = err;
      //   console.error(err);
      }
    },
    // async deleteConferenceData(conf: string): Promise<void> {
    async deleteConferenceData(): Promise<void> {
      // delConference(conf)
      //   .then(() => {
      this.sel = null;
      this.updateConferencesData();
      // })
      // .catch((err) => {
      //   if (err.response.status === 422) {
      //     this.$store.commit('noAuth', true);
      //   } else {
      //     this.$store.commit('error', true);
      //   }
      //   console.error(err);
      // });
      this.exit();
    },
    exit(): void {
      this.showConfirm = false;
    },
    // async patchConferences(
    //   conf: conferenceType.getConference,
    //   data: conferenceType.updateConference,
    // ): Promise<void> {
    patchConferences(): void {
      // try {
      //   const responses = new Promise((resolve) => {
      //     resolve(updateConference(conf._id, data));
      //   });
      //   responses.then(() => {
      this.updateConferencesData();
      //   });
      // } catch (err) {
      //   console.error(err);
      // }
    },
    readable(d: string, e: string): string {
      const sDate = new Date(d);
      const eDate = new Date(e);
      const ye = (y: Date) => new Intl.DateTimeFormat('en', { year: 'numeric' }).format(y);
      const mo = (m: Date) => new Intl.DateTimeFormat('en', { month: 'short' }).format(m);
      const da = (day: Date) => new Intl.DateTimeFormat('en', { day: '2-digit' }).format(day);
      let r: string = '';
      if (typeof e === 'string') {
        r = `${da(sDate)} ${mo(sDate)} - ${da(eDate)} ${mo(eDate)} ${ye(eDate)}`;
      } else if (typeof e === 'undefined') {
        r = ye(sDate);
      }
      return r;
    },
    yearOnly(d: string) {
      return d;
    },
  },
  created() {
    this.updateConferencesData();
    this.$root.$on('context', this.context);
  },
  beforeDestroy() {
    this.$root.$off('context', this.context);
  },
  computed: {
    ...mapState({
      width: (state: any) => state.Global.widthWindow,
      notAuthorized: (state: any) => state.Global.notAuthorized,
      me: (state: any) => state.Global.me,
      contextData: (state: any) => state.Global.contextData,
    }),
    transName(): string {
      if (this.width > 960) return 'fade';
      if (this.sel === null) return 'slide-right';
      return 'slide-left';
    },
  },
});
